import React from 'react';

import Box from '@mui/material/Box';

import useIsInsurance from 'hooks/useIsInsurance';

import CaseStudyLanding from './components/CaseStudyLanding';
import ContactUs from './components/ContactUs';
import Conversations from './components/Conversations';
import FeaturesDescriptionZeller from './components/FeaturesDescriptionZeller';
import FeaturesZeller from './components/FeaturesZeller';
import Footer from './components/Footer';
import HeaderPage from './components/HeaderPage';
import IncludedInsurance from './components/IncludedInsurance';
import InsuranceHeader from './components/InsuranceHeader';
import Navigation from './components/Navigation';
import StatsSection from './components/StatsSection';
import ZellerClients from './components/ZellerClients';

const App = () => {
  const isInsurance = useIsInsurance();

  if (isInsurance) {
    return (
      <Box sx={{ backgroundColor: '#F1F6FC', padding: 0 }}>
        <Navigation />
        <InsuranceHeader />
        <Conversations />
        <IncludedInsurance />
        <Footer />
      </Box>
    );
  }
  return (
    <Box sx={{ backgroundColor: '#F1F6FC', padding: 0 }}>
      <Navigation />
      <HeaderPage />
      <ZellerClients />
      <FeaturesZeller />
      <FeaturesDescriptionZeller />
      <StatsSection />
      <CaseStudyLanding />
      <ContactUs />
      <Footer />
    </Box>
  );
};

export default App;
